import type { Permissions } from '@/context/auth/types';

import { useHasAnyPermission, useHasAnyPermissionPrefix, useHasPermission } from '@/hooks/usePermissions';
import React from 'react';
import { Navigate } from 'react-router';

type SinglePermissionCheck = {
  name: Permissions;
  names?: never;
  prefixes?: never;
};

type MultiplePermissionsCheck = {
  name?: never;
  names: Permissions[];
  prefixes?: never;
};

type PrefixPermissionsCheck = {
  name?: never;
  names?: never;
  prefixes: Permissions[];
};

type PermissionGuardProps = {
  children: React.ReactNode;
  redirect?: string;
} & (SinglePermissionCheck | MultiplePermissionsCheck | PrefixPermissionsCheck);

export default function PermissionGuard(props: PermissionGuardProps) {
  const { children, redirect } = props;
  const name = 'name' in props ? props.name : undefined;
  const names = 'names' in props ? props.names : [];
  const prefixes = 'prefixes' in props ? props.prefixes : [];
  const hasNamedPermission = useHasPermission({ name });
  const hasAnyPermission = useHasAnyPermission(names ?? []);
  const hasAnyPrefixedPermission = useHasAnyPermissionPrefix(prefixes ?? []);
  const hasPermission = hasNamedPermission || hasAnyPermission || hasAnyPrefixedPermission;

  if (hasPermission) {
    return <>{children}</>;
  }

  return redirect ? <Navigate to={redirect} /> : null;
}
